import React from 'react';

import {FlatButton} from '@pb/kit-component-button';
import {Group, Item} from '@pb/kit-component-group';
import {ToolItem, ToolsRibbon, ToolsRibbonGroup} from '@pb/kit-component-tools-ribbon';

type Props = {
    pageIds: string[],
    selectedIds: string[],
    pageSelectedCount: number,
    onSelectPage: () => void,
    onClear: () => void,
};
export const ToolsRibbonComponent: React.FC<Props> = ({
    pageIds,
    selectedIds,
    pageSelectedCount,
    // onSelectPage,
    onClear,
}) => {
    const showSelectPage = pageIds.length > 0 && pageSelectedCount < pageIds.length;
    const showClear = selectedIds.length > 0;
    return (
        <ToolsRibbon shadow={false} justify="space-between">
            <Item grow={1}>
                <Group>
                    <ToolsRibbonGroup>
                        <ToolItem>
                            <strong></strong>
                        </ToolItem>
                    </ToolsRibbonGroup>
                    <ToolsRibbonGroup>
                        {showSelectPage ? (
                            <ToolItem>
                                {/* Temporarily hiding select page button until implementation bulk operations */}
                                <div></div>
                            </ToolItem>
                        ) : null}
                        {showClear ? (
                            <ToolItem>
                                <FlatButton onClick={onClear}>Deselect All</FlatButton>
                            </ToolItem>
                        ) : null}
                    </ToolsRibbonGroup>
                </Group>
            </Item>
        </ToolsRibbon>
    );
};
